﻿import { Button, Select, Space } from "antd";
import { array, bool, func, object, oneOfType, string } from "prop-types";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import * as S from "../styled";

const { Option } = Select;

export const TableDropDownFilter = ({
  inputRef,
  onSubmit,
  onReset,
  confirm,
  queryParamValue,
  options,
  singleChoice,
}) => {
  const intl = useIntl();
  const [value, setValue] = useState(queryParamValue || []);

  useEffect(() => {
    setValue(queryParamValue);
  }, [queryParamValue]);

  const handleChange = (selectedValue) => {
    setValue(selectedValue);
    onSubmit(selectedValue);
  };

  const handleReset = () => {
    setValue([]);
    confirm();
    onReset();
  };

  const dropDownOptions = () =>
    options ? (
      options.map((option, index) => (
        <Option key={`${option.id}`} value={option.id}>
          {intl.formatMessage({
            id: option.id,
            defaultMessage: option.fallback,
          })}
        </Option>
      ))
    ) : (
      <>
        <Option key={"general.yes"} value={true}>
          {intl.formatMessage({ id: "general.yes", defaultMessage: "Yes" })}
        </Option>
        <Option key={"general.no"} value={false}>
          {intl.formatMessage({ id: "general.no", defaultMessage: "No" })}
        </Option>
      </>
    );

  return (
    <S.FilterWrapper>
      <S.FilterDropdown
        ref={inputRef}
        mode={!singleChoice ? "multiple" : null}
        allowClear
        placeholder={intl.formatMessage({
          id: "tableFilters.dropDownPlaceholder",
        })}
        value={value}
        onChange={handleChange}
        data-test-id={"filter-dropdown"}
      >
        {dropDownOptions()}
      </S.FilterDropdown>
      <Space>
        <Button
          onClick={handleReset}
          size="small"
          data-test-id={"filter-reset-button"}
        >
          {intl.formatMessage({ id: "general.reset" })}
        </Button>
      </Space>
    </S.FilterWrapper>
  );
};

TableDropDownFilter.propTypes = {
  inputRef: object,
  options: array,
  queryParamValue: oneOfType([array, string]),
  singleChoice: bool,
  onReset: func,
  onSubmit: func,
  confirm: func,
};
